module.exports = __webpack_public_path__ + "static/media/project2.30067664.png";